import type { Asset } from '@avs/contract';
import { Icon } from '../../icons/Icon.js';
import { useMe } from '../../hooks/useMe.js';
import { KIND_LABEL } from '../../utils/kinds.js';
import type { WizardState } from './types.js';
import { expandPairs } from './types.js';

type Props = {
  state: WizardState;
  assetName: (id: string) => string;
};

/** 预览确认：展开成 K 个任务清单 + 额度消耗 */
export function StepPreview({ state, assetName }: Props) {
  const { me } = useMe();
  const tasks = expandPairs(state.pairs);
  const cost = tasks.length;
  const remaining = me?.credits ?? null;
  const insufficient = remaining !== null && remaining < cost;

  return (
    <div className="wiz-preview">
      <div className="card" style={{ maxWidth: 820, margin: '0 auto' }}>
        <div className="between" style={{ marginBottom: 'var(--space-s)' }}>
          <div>
            <div className="block-title">预览确认</div>
            <div className="muted small" style={{ marginTop: 4 }}>
              {KIND_LABEL[state.kind]} · 策略「{state.params.strategy}」· {state.params.resolution} · {state.params.duration}
            </div>
          </div>
          <div className={'wiz-cost' + (insufficient ? ' low' : '')}>
            <div className="wiz-cost-num">{cost}</div>
            <div className="wiz-cost-label">个任务 · 消耗 {cost} 额度</div>
            {remaining !== null && <div className="muted small">剩余 {remaining}</div>}
          </div>
        </div>

        {insufficient && (
          <div className="alert alert-danger" style={{ marginBottom: 'var(--space-s)' }}>
            <Icon name="warning" size={18} />
            <div className="alert-body">额度不足：需要 {cost}，剩余 {remaining}。请减少配对或联系管理员加额度。</div>
          </div>
        )}

        <table className="table">
          <thead>
            <tr><th style={{ width: 40 }}>#</th><th>源视频</th><th>参考素材</th></tr>
          </thead>
          <tbody>
            {tasks.map((t, i) => (
              <tr key={i}>
                <td className="mono-sm">{i + 1}</td>
                <td><span className="row" style={{ gap: 6 }}><Icon name="video" size={14} />{assetName(t.videoAssetId)}</span></td>
                <td><span className="row" style={{ gap: 6 }}><Icon name="image" size={14} />{assetName(t.refAssetId)}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
